'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  init: function init() {
    var _this = this;

    var forms = document.querySelectorAll('.gform_wrapper');

    if (forms && forms.length) {
      forms.forEach(function (form) {
        form.addEventListener('focus', function (e) {
          var input = e.target;

          _this.inputFocus(input);
        }, true);

        form.addEventListener('blur', function (e) {
          var input = e.target;

          _this.inputBlur(input);
        }, true);

        setTimeout(function () {
          _this.setFormHeight(form);
        }, 500);
      });

      $(document).on('gform_post_render', function (e, id) {
        _this.checkInputs(id);
      });

      $(document).on('gform_confirmation_loaded', function (event, form_id) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ajax_enquire_form_success',
          formID: form_id
        });
      });
    }
  },
  setFormHeight: function setFormHeight(form) {
    var formContainer = form.closest('.form');

    if (formContainer && !formContainer.classList.contains('height-set')) {
      formContainer.style.minHeight = formContainer.offsetHeight + 'px';
      formContainer.classList.add('height-set');
    }
  },
  checkInputs: function checkInputs(form_id) {
    var _this2 = this;

    var form = document.querySelector('#gform_' + form_id);
    // const form = document.querySelector('form-fields');

    if (form) {
      var fieldSection = form.querySelector('.gform_fields');
      var inputs = fieldSection.querySelectorAll('input, textarea, select');

      if (inputs.length) {
        var inputsArr = Array.prototype.slice.call(inputs);

        inputsArr.forEach(function (input) {
          if (input.value.length !== 0) {
            _this2.inputFocus(input);
          }
        });
      }
    }
  },
  inputFocus: function inputFocus(input) {
    var fieldWrapper = input.closest('.gfield');

    if (fieldWrapper) {
      fieldWrapper.classList.add('field--focus');
    }
  },
  inputBlur: function inputBlur(input) {
    var fieldWrapper = input.closest('.gfield');

    if (fieldWrapper && input.value.length == 0) {
      fieldWrapper.classList.remove('field--focus');
    }
  }
};


// WEBPACK FOOTER //
// ./scripts/components/gforms.js